var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadsLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0012,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3982 13.0839C25.8054 13.2607 26.0474 13.6848 25.9923 14.1253L25.1328 21.0012H33C33.388 21.0012 33.741 21.2257 33.9056 21.5771C34.0702 21.9285 34.0166 22.3433 33.7682 22.6414L23.7682 34.6414C23.484 34.9824 23.009 35.0953 22.6018 34.9185C22.1946 34.7418 21.9527 34.3177 22.0077 33.8772L22.8672 27.0012H15C14.612 27.0012 14.259 26.7768 14.0944 26.4254C13.9298 26.074 13.9834 25.6591 14.2318 25.361L24.2318 13.361C24.516 13.02 24.991 12.9072 25.3982 13.0839ZM17.1351 25.0012H24C24.2868 25.0012 24.5599 25.1244 24.7497 25.3394C24.9395 25.5545 25.0279 25.8406 24.9923 26.1253L24.4154 30.7408L30.865 23.0012H24C23.7132 23.0012 23.4402 22.8781 23.2503 22.663C23.0605 22.448 22.9722 22.1618 23.0077 21.8772L23.5847 17.2617L17.1351 25.0012Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadsLink2);
export default __webpack_public_path__ + "static/media/downloads-link2.526b1b0a16711736221c8257b2173785.svg";
export { ForwardRef as ReactComponent };